import request from '@/utils/request'

//用户登录注册模块
export const userApi = {
    //注册
    register: (data) => request.post('/oauth/account/register', data),
    //获取公钥
    getPublicKey: (data) => request.get('/oauth/rsa/public/key', data),
    // 登录
    login: (data) => request.post('/oauth/account/login', data),
}

// 系统枚举/字典模块
export const systemApi = {
    // 获取系统枚举数据
    getEnums: (params) => request.get('/chemical/system/commons/enums', { params }),
}

// OSS STS 凭证接口
export const ossApi = {
    // 获取 OSS STS 临时凭证
    getSTSToken: () => request.get('/sys/sts/token'),
}

// 设备模块
export const deviceApi = {
    // 设备类型列表
    getTypes: () => request.get('/chemical/device/types'),
    // 设备分页查询
    getPage: (data) => request.post('/chemical/device/page', data),
    // 校验设备编码是否存在
    checkCodeExist: (code) => request.get(`/chemical/device/exist/${code}`),
    // 获取详情 (设置)
    getDetail: (id) => request.get(`/chemical/device/detail/${id}`),
    //获取标签二维码...
    getQrcode: (id) => request.get(`/chemical/device/qrcode/${id}`),
    // 新增设备
    save: (data) => request.post('/chemical/device/save', data),
    //修改审批单...
    update: (data) => request.post('/chemical/device/update', data),
    // 扫码标签
    getTag: (id) => request.get(`/chemical/device/tag/${id}`),
    //修改资质文件...
    upsetFile: (data) => request.post('/chemical/device/upsetFile', data),
    // 查询库位标签
    getLayerTag: (id) => request.get(`/chemical/device/layer/${id}`),
    // 获取设备下拉列表
    getDeviceOptions: () => request.get('/chemical/device/deviceOptions'),
    // 获取库位下拉列表
    getLocationOptions: (id) => request.get(`/chemical/device/locationOptions/${id}`),
    // 获取货架下拉
    getLayerOptions: (id) => request.get(`/chemical/device/layerOptions/${id}`),
}

// 采购模块
export const procureApi = {
    // 分页查询采购订单
    getPage: (data) => request.post('/chemical/procure/order/page', data),
    // 新增采购订单（手动填写）
    save: (data) => request.post('/chemical/procure/order/save', data),
    // 修改采购订单
    update: (data) => request.put('/chemical/procure/order/update', data),
    // 导入采购单
    importOrder: (data, config) => request.post('/chemical/procure/order/importOrder', data, config),
    // 模糊匹配化学品
    chemLike: (params) => request.get('/chemical/procure/order/chem/like', { params }),
    // 查询详情
    getOrderById: (id) => request.get(`/chemical/procure/order/detailById/${id}`),
    // 确认采购单
    confirm: (data) => request.put('/chemical/procure/order/confirm', data),
    // 上传前置的业务前缀
    preUpload: (params) => request.get('/chemical/procure/order/preUpload', { params }),
}

// 经办人模块
export const handlerApi = {
    // 分页查询经办人列表
    getPage: (data) => request.post('/chemical/chem/handler/page', data),
    // 保存或更新经办人
    saveOrUpdate: (data) => request.post('/chemical/chem/handler/saveOrUpdate', data),
    // 删除经办人
    remove: (id) => request.delete(`/chemical/chem/handler/delete/${id}`),
    // 根据姓名模糊匹配经办人
    like: (params) => request.get('/chemical/chem/handler/like', { params }),
}

// 入库模块
export const inboundApi = {
    // 入库分页查询
    getPage: (data) => request.post('/chemical/inventory/order/orderPage', data),
    // 根据id获取详情
    getById: (id) => request.get(`/chemical/inventory/order/getById/${id}`),
    // 获取物料信息
    getMaterialById: (id) => request.get(`/chemical/inventory/order/material/${id}`),
    // 已打印标签（打印成功后通知后端标记，打印列表会剔除已打印项）
    alreadyPrinted: (id) => request.get(`/chemical/inventory/order/printed/${id}`),
    // 确认库存单
    confirm: (data) => request.put('/chemical/inventory/order/confirm', data),
    // 选择设备入库...
    bindDevice: (data) => request.post('/chemical/inventory/order/bindDevice', data),
    // 绑定物料...
    bindMaterial: (data) => request.post('/chemical/inventory/order/bindMaterial', data),
    //物料目录查询...
    getMatPage: (data) => request.post('/chemical/inventory/order/matPage', data),
    //物料查询
    getMat: (id) => request.get(`/chemical/inventory/order/mat/${id}`),
    // 查看物料标签
    matById: (id) => request.get(`/chemical/inventory/order/matById/${id}`)
}

//物料申领模块
export const applyApi = {
    //申领单分页查询
    getPage: (data) => request.post('/chemical/mat/apply/page', data),
    //申领单详情
    getDetail: (id) => request.get(`/chemical/mat/apply/detail/${id}`),
    //创建申请单
    submit: (data) => request.post('/chemical/mat/apply/submit',  data),
    //审批
    audit: (data) => request.put('/chemical/mat/apply/audit', data),
}

//出库模块
export const outboundApi = {
    //分页查询
    getPage: (data) => request.post('/chemical/outbound/mat/page', data),
    //详情
    getDetail: (id) => request.get(`/chemical/outbound/mat/outboundById/${id}`),
    //审批
    audit: (data) => request.put('/chemical/outbound/mat/audit', data),
    //出库
    action: (data) => request.post('/chemical/outbound/mat/action', data),
}
